import { render } from "./TandaList.vue?vue&type=template&id=12a8a845"
import script from "./TandaList.vue?vue&type=script&lang=js"
export * from "./TandaList.vue?vue&type=script&lang=js"

import "./TandaList.vue?vue&type=style&index=0&id=12a8a845&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__